export default "__VITE_ASSET__BeQ8uaIO__"